export default class CompanyParser {
  static parseFromAPI(data) {
    return {
      segment: data.segment,
      name: data.name,
      tradingName: data.trading_name,
      cnpj: data.cnpj,
      documentType: data.document_type,
      mainDocument: data.main_document,
      defaultPassword: data.default_password,
    };
  }

  static parseToAPI(data) {
    return {
      segment: data.segment,
      name: data.name,
      trading_name: data.tradingName,
      cnpj: data.cnpj,
      document_type: data.documentType,
      main_document: data.mainDocument,
      default_password: data.defaultPassword,
    };
  }
}
